import project from '@/router/pto/project/project'
import pto from '@/router/pto/project/pto'
import estimate from '@/router/pto/project/estimate'

export default [
  {
    path: 'project',
    name: 'PtoProject',
    component: () => import('@/views/Pto/Project/PtoProject.vue')
  },

  {
    path: 'project/:projectId',
    name: 'PtoProjectDetailed',
    component: () => import('@/views/Pto/Project/PtoProjectDetailed.vue'),
    redirect: {
      name: 'PtoProjectDetailedProject'
    },
    children: [
      ...project,
      ...pto,
      ...estimate,
      {
        path: 'delivery',
        name: 'PtoProjectDelivery',
        component: () => import('@/views/Pto/Project/delivery/PtoProjectDelivery.vue')
      }
    ]
  }
]
